// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3LDpj","large":"styles_large__3mqXj"};